<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

    <div>

        <v-data-table
            :headers="headers"
            :items="optionLocales"
            hide-default-footer
            hide-default-header
            disable-pagination
            dense
        >
            <template v-slot:body="{ items }">
                <tbody>
                <tr v-for="(item, index) in items" :key="item.uuid">
                    <td class="text-left pl-0">
                        <div class="d-flex pt-2 pb-2">
                            <v-chip label class="ml-2 mr-0">{{ index + 1 }}</v-chip>

                            <v-text-field
                                dense
                                color="primary"
                                rounded
                                placeholder="Please enter option text"
                                background-color="transparent"
                                hide-details
                                autocomplete="false"
                                class="elevation-0 flex-grow-1 mr-2 mb-1"
                                v-model="item.option_text"
                                @blur="optionNameChanged(item)"
                            />
                        </div>
                    </td>
                </tr>
                </tbody>
            </template>

        </v-data-table>

        <json v-if="false" :data="dataVariable"/>

    </div>
</template>

<script>

import Json from 'vue-json-pretty';

export default {

    components: {
        Json
    },

    props: {
        dataVariable: {
            type: Object | null,
            required: true
        },
        availableLocales: {
            type: Array | null,
            required: true
        },
        editLocale: {
            type: Object | null,
            required: true,
        }
    },

    computed: {
        optionLocales() {
            let items = [];

            if (this.dataVariable && this.editLocale) {

                JSON.parse(JSON.stringify(this.dataVariable.options))
                    .sort((a, b) => {
                        return a.order - b.order;
                    })
                    .forEach(option => {
                        let optionLocale = option.locales.find(locale => {
                            if (locale.locale_id === this.editLocale.id) {
                                return Object.assign(locale, {option_id: option.id});
                            }
                        });

                        items.push(optionLocale);
                    });
            }
            return items;
        }
    },

    data() {
        return {
            maxchars: v => v.length <= 200 || 'Option text too long!',
            headers: [
                {
                    text: 'Option name',
                    align: 'left',
                    sortable: false,
                    value: 'option_text'
                }
            ]
        }
    },

    methods: {
        optionNameChanged(changedOption) {

            let dataVariable = JSON.parse(JSON.stringify(this.dataVariable));

            const optionIndex = dataVariable.options.findIndex(option => {
                return option.id === changedOption.option_id
            });

            const localeIndex = dataVariable.options[optionIndex].locales.findIndex(locale => locale.locale_id === changedOption.locale_id);

            dataVariable.options[optionIndex].locales[localeIndex] = Object.assign({}, changedOption);

            this.$emit('change', dataVariable.options);
        },
        emit() {
            this.$emit('change', this.optionLocales);
        }
    },
}
</script>

<style scoped>

tr:hover {
    background-color: transparent !important;
}

</style>